import * as R from 'ramda';
import { LodgmentTypeSpecification } from '../../LodgmentTypeSpecification';
import { HeatingSystem } from '../../HeatingSystem';

export const setLodgmentTypeSpecificationHeatingSystem =
  (heatingSystem: HeatingSystem | undefined) =>
  (lodgmentTypeSpecification: LodgmentTypeSpecification): LodgmentTypeSpecification =>
    R.assoc('heatingSystem', heatingSystem)(lodgmentTypeSpecification);
